module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gDSVe"))).then(() => parcelRequire('hEqeo'));